export default __webpack_public_path__ + "static/Case Study - Nani-e4f5f315b68d75bfbb9489dd6dc82268.pdf";